import { createAction, handleActions } from 'redux-actions';

/** ****************************************************************
 * Constants *******************************************************
 * ****************************************************************
 */
export const SET_CURRENT_REVISION = 'crowdspring/focusgroups/SET_CURRENT_REVISION';

/** ****************************************************************
 * Action Creators *******************************************************
 * ****************************************************************
 */
export const setCurrentRevision = createAction(SET_CURRENT_REVISION);

/** ****************************************************************
 * Initial State *******************************************************
 * ****************************************************************
 */
export const initialState = {
  currentRevisionId: null,
};

/** ****************************************************************
 * Reducer *******************************************************
 * ****************************************************************
 */
const resultsReducer = handleActions({
  [setCurrentRevision]: (state, action) => ({
    ...state,
    currentRevisionId: action.payload,
  }),
}, initialState);

export default resultsReducer;
